import { CircleAlert, Hourglass } from "lucide-react";

import { Pressable } from "../../Pressable";
import { Label } from "../../typography/Label";
import { useChat } from "../ChatContext";
import { useMessage } from "./Context";

export function MessageStatus() {
    const { deliveryStatus, onRetrySend } = useMessage();
    const { labels } = useChat();

    if (deliveryStatus === "sending") {
        return (
            <span className="inline-flex items-center gap-8">
                <Hourglass aria-hidden="true" className="size-16 text-text-tertiary" />

                <Label size="xsmall" weight="bold" color="secondary" className="trim">
                    {labels.sendingMessage}
                </Label>
            </span>
        );
    }

    return (
        <Pressable
            isDisabled={!onRetrySend}
            aria-label={labels.retrySend}
            onPress={onRetrySend}
        >
            <span className="inline-flex items-center gap-8">
                <CircleAlert aria-hidden="true" className="size-16 text-status-error" />

                <Label size="xsmall" weight="bold" color="secondary" className="trim">
                    {labels.sendingMessageFailed}
                </Label>
            </span>
        </Pressable>
    );
}
